import { Filters, List, Page, Row, SearchInput, SpellListItem } from '../../components';
import './SpellsReferencePage.scss';

import { SPELLS } from '../../data';
import { useCallback, useContext, useEffect, useState, useRef } from 'react';
import {  applyAllFilters } from '../../util/spell';
import { ActiveListContext } from '../../context/ActiveListContext';
import { AuthContext, ScrollContext, SettingsContext } from '../../context';
import { Alert, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export const SpellsReferencePage = () => {
    const { isLoggedIn } = useContext(AuthContext);
    
    const { 
        activeList,
        addSpell,
        hasSpell,
        removeSpell
    } = useContext(ActiveListContext);
    const scrollRef = useRef(null);

    const [ searchString, setSearchString ] = useState('');
    const [ filters, setFilters ] = useState({});

    const { scrollPosition, setScrollPosition } = useContext(ScrollContext);

    const settings = useContext(SettingsContext);

    const handleScroll = useCallback(() => {
        setScrollPosition(scrollRef.current.scrollTop);
    }, [setScrollPosition]);

    useEffect(() => {
        const cleanupRef = scrollRef.current;
        if (scrollPosition !== 0) {
            scrollRef.current.scrollTo({top: scrollPosition});
        }

        cleanupRef.addEventListener("scroll", handleScroll);

        return () => cleanupRef.removeEventListener("scroll", handleScroll)
    }, [handleScroll, scrollPosition]);

    const compareSpells = (s1, s2) => {
        if (s1.level === s2.level) {
            return s1.name.localeCompare(s2.name);
        }
    
        return s1.level - s2.level;
    };
    
    const filteredSpells = () => {
        const regex = new RegExp(searchString.toLowerCase());
        
        return SPELLS
            .filter(({ name }) => regex.test(name.toLowerCase()))
            .filter(s => applyAllFilters(s, filters, settings))
            .sort(compareSpells);
    };

    return (
        <Page className="SpellsReferencePage">
            {!isLoggedIn && 
                <Alert severity='info'><Link to="emaillinksignin">Create an account</Link> to save your own lists.</Alert>
            }
            <Row className='headingRow'>
                <h2>All Spells ({filteredSpells().length})</h2>
                {isLoggedIn && 
                    <Button variant='contained' color='secondary' href="/lists">Lists</Button>
                }
            </Row>
            <SearchInput 
                value={searchString}
                onChange={setSearchString}
            />
            <Filters filters={filters} onChange={setFilters} />
            <List ref={scrollRef}>
                {filteredSpells().map((s, i) => (
                    <SpellListItem 
                        key={i} 
                        spell={s} 
                        addable={!!activeList}
                        added={hasSpell(s)}
                        onAdd={() => addSpell(s)}
                        onRemove={() => removeSpell(s)}
                    />
                ))}
            </List>
        </Page>
    );
};